var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { isOfType } from "typesafe-actions";
import { combineEpics } from "redux-observable";
import { UNIFIED_API_ACTION_PREFIX } from "./constants.js";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from "@ane/core/lib/models";
import { createSelector } from "reselect";
const updateStateArray = (arr, entity) => {
  const findIndex = arr.findIndex((x) => x.id === entity.id);
  return findIndex === -1 ? [...arr, __spreadValues({}, entity)] : [...arr.map((item, index) => index === findIndex ? __spreadValues(__spreadValues({}, item), entity) : __spreadValues({}, item))];
};
const getLoadedActionPrefix = (epicReducer) => epicReducer.actionCreators.loaded({}, {}).type;
const createUnifiedRestApi = (restService, entityActionPrefix, getSlice) => {
  const tryGetSlice = (state) => {
    try {
      return getSlice(state);
    } catch (e) {
      return getDefaultReducerState();
    }
  };
  const getAsyncInput = {
    actionPrefix: `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/GET_ASYNC`,
    reduxKeyNested: ({ id }) => ["getAsync", id],
    loadResource: ({ workspaceId, id }) => restService.getAsync(workspaceId, id),
    onCompleteSuccess: (result) => result
  };
  const createOrUpdateAsyncInput = {
    actionPrefix: `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/CREATE_UPDATE_ASYNC`,
    reduxKeyNested: ({ id }) => ["createOrUpdateAsync", id],
    loadResource: ({ workspaceId, id, entity }) => restService.createOrUpdateAsync(workspaceId, id, entity),
    onCompleteSuccess: (result) => result
  };
  const deleteAsyncInput = {
    actionPrefix: `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/DELETE_ASYNC`,
    reduxKeyNested: ({ id }) => ["deleteAsync", id],
    loadResource: ({ workspaceId, id }) => restService.deleteAsync(workspaceId, id),
    onCompleteSuccess: (result) => result
  };
  const queryAsyncInput = {
    actionPrefix: `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/QUERY_ASYNC`,
    reduxKeyNested: ({ query, additionalQueryParams }) => ["queryAsync", buildOdataQuery(query, additionalQueryParams)],
    loadResource: ({ workspaceId, query, additionalQueryParams }) => restService.queryAsync(workspaceId, query, additionalQueryParams),
    onCompleteSuccess: (result) => result
  };
  const additionalActions = { createOrUpdateAsync: [], getAsync: [], miscellaneousAsync: [] };
  const getDefaultReducerState = () => ({
    entityMap: {},
    getAsync: {},
    createOrUpdateAsync: {},
    deleteAsync: {},
    queryAsync: {},
    additionalActions: {
      createOrUpdateAsync: additionalActions.createOrUpdateAsync.reduce(
        (acc, x) => __spreadProps(__spreadValues({}, acc), {
          [x.actionName]: {}
        }),
        {}
      ),
      getAsync: additionalActions.getAsync.reduce(
        (acc, x) => __spreadProps(__spreadValues({}, acc), {
          [x.actionName]: {}
        }),
        {}
      ),
      miscellaneousAsync: additionalActions.miscellaneousAsync.reduce(
        (acc, x) => __spreadProps(__spreadValues({}, acc), {
          [x.actionName]: {}
        }),
        {}
      )
    }
  });
  return {
    createOrUpdateAsyncInput,
    getAsyncInput,
    queryAsyncInput,
    deleteAsyncInput,
    addMiscellaneousAction: (actionName, loadResource) => {
      const prefix = `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/${actionName}`;
      const epicReducer = loadResourcesUtils({
        loadResource,
        actionPrefix: prefix,
        reduxKeyNested: ({ id }) => ["additionalActions", "miscellaneousAsync", actionName, id],
        onCompleteSuccess: (result) => result
      });
      const meta = {
        actionName,
        prefix,
        epicReducer,
        isOfType: (action) => isOfType(getLoadedActionPrefix(epicReducer), action),
        selectAsyncRequest: (state, id) => {
          var _a2, _b, _c;
          return ((_c = (_b = (_a2 = tryGetSlice(state).additionalActions) == null ? void 0 : _a2.miscellaneousAsync) == null ? void 0 : _b[actionName]) == null ? void 0 : _c[id]) || getDefaultAsyncWrapperObj();
        }
      };
      additionalActions.miscellaneousAsync.push(meta);
      const _a = meta, { epicReducer: _e, prefix: _p } = _a, rest = __objRest(_a, ["epicReducer", "prefix"]);
      return __spreadValues({
        actions: epicReducer.actionCreators
      }, rest);
    },
    /**
     * Adds an additional "get" action to this slice.
     * @param actionName The name of the action.
     * @param loadResource The function to load the resource.
     * @returns The metadata and some helper functions.
     */
    addGetAction: (actionName, loadResource) => {
      const prefix = `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/${actionName}`;
      const epicReducer = loadResourcesUtils({
        loadResource,
        actionPrefix: prefix,
        reduxKeyNested: ({ id }) => ["additionalActions", "getAsync", actionName, id],
        onCompleteSuccess: (result) => result
      });
      const meta = {
        actionName,
        prefix,
        epicReducer,
        isOfType: (action) => isOfType(getLoadedActionPrefix(epicReducer), action),
        selectAsyncRequest: (state, id) => {
          var _a2, _b, _c;
          return ((_c = (_b = (_a2 = tryGetSlice(state).additionalActions) == null ? void 0 : _a2.getAsync) == null ? void 0 : _b[actionName]) == null ? void 0 : _c[id]) || getDefaultAsyncWrapperObj();
        }
      };
      additionalActions.getAsync.push(meta);
      const _a = meta, { epicReducer: _e, prefix: _p } = _a, rest = __objRest(_a, ["epicReducer", "prefix"]);
      return __spreadValues({
        actions: epicReducer.actionCreators
      }, rest);
    },
    /**
     * Adds an additional "createOrUpdate" action to this slice. The results of this action are normalized into the entity map.
     * @param actionName The name of the action.
     * @param loadResource The function to load the resource.
     * @returns The metadata and some helper functions.
     */
    addCreateOrUpdateAction: (actionName, loadResource) => {
      const prefix = `${UNIFIED_API_ACTION_PREFIX}/${entityActionPrefix}/${actionName}`;
      const epicReducer = loadResourcesUtils(__spreadProps(__spreadValues({}, createOrUpdateAsyncInput), {
        loadResource,
        actionPrefix: prefix,
        reduxKeyNested: ({ id }) => ["additionalActions", "createOrUpdateAsync", actionName, id]
      }));
      const meta = {
        actionName,
        prefix,
        epicReducer,
        isOfType: (action) => isOfType(getLoadedActionPrefix(epicReducer), action),
        selectAsyncRequest: (state, id) => {
          var _a2, _b, _c;
          return ((_c = (_b = (_a2 = tryGetSlice(state).additionalActions) == null ? void 0 : _a2.createOrUpdateAsync) == null ? void 0 : _b[actionName]) == null ? void 0 : _c[id]) || getDefaultAsyncWrapperObj();
        }
      };
      additionalActions.createOrUpdateAsync.push(meta);
      const _a = meta, { epicReducer: _e, prefix: _p } = _a, rest = __objRest(_a, ["epicReducer", "prefix"]);
      return __spreadValues({
        actions: epicReducer.actionCreators
      }, rest);
    },
    create: () => {
      const createOrUpdateAsync = loadResourcesUtils(createOrUpdateAsyncInput);
      const getAsync = loadResourcesUtils(getAsyncInput);
      const queryAsync = loadResourcesUtils(queryAsyncInput);
      const deleteAsync = loadResourcesUtils(deleteAsyncInput);
      const isGetAction = (action) => isOfType(getLoadedActionPrefix(getAsync), action);
      const isCreateUpdateAction = (action) => isOfType(
        [
          getLoadedActionPrefix(createOrUpdateAsync),
          ...additionalActions.createOrUpdateAsync.map((x) => getLoadedActionPrefix(x.epicReducer))
        ],
        action
      );
      const isQueryAction = (action) => isOfType(getLoadedActionPrefix(queryAsync), action);
      const isDeleteAction = (action) => isOfType(getLoadedActionPrefix(deleteAsync), action);
      const normalizationReducer = (state = getDefaultReducerState(), action) => {
        var _a, _b, _c, _d, _e, _f;
        let draft = __spreadValues({}, state);
        if ((isCreateUpdateAction(action) || isGetAction(action)) && action.payload && ((_a = action.outputPayloadAsync) == null ? void 0 : _a.data)) {
          draft.entityMap[action.payload.id] = __spreadValues(__spreadValues({}, draft.entityMap[action.payload.id]), action.outputPayloadAsync.data);
        }
        if (isQueryAction(action) && action.payload && ((_d = (_c = (_b = action.outputPayloadAsync) == null ? void 0 : _b.data) == null ? void 0 : _c.value) == null ? void 0 : _d.length) && !action.payload.skipEntityMerge) {
          for (const entity of action.outputPayloadAsync.data.value) {
            draft.entityMap[entity.id] = __spreadValues(__spreadValues({}, draft.entityMap[entity.id]), entity);
          }
        }
        if (isDeleteAction(action) && ((_e = action.payload) == null ? void 0 : _e.id) && ((_f = action.outputPayloadAsync) == null ? void 0 : _f.status) === AsyncRequestStatus.Completed) {
          delete draft.entityMap[action.payload.id];
          draft.entityMap = __spreadValues({}, draft.entityMap);
        }
        return __spreadProps(__spreadValues({}, draft), {
          entityMap: __spreadValues({}, draft.entityMap)
        });
      };
      const selectAll = createSelector(
        (state) => {
          var _a;
          return ((_a = tryGetSlice(state)) == null ? void 0 : _a.entityMap) || {};
        },
        (x) => Object.values(x).filter((x2) => !!x2).map((x2) => x2)
      );
      return {
        getDefaultReducerState,
        epic: combineEpics(
          createOrUpdateAsync.epic,
          getAsync.epic,
          queryAsync.epic,
          deleteAsync.epic,
          ...additionalActions.createOrUpdateAsync.map((x) => x.epicReducer.epic),
          ...additionalActions.getAsync.map((x) => x.epicReducer.epic),
          ...additionalActions.miscellaneousAsync.map((x) => x.epicReducer.epic)
        ),
        reducer: (state = getDefaultReducerState(), action) => {
          let draft = __spreadValues({}, state);
          draft = createOrUpdateAsync.reduxChange(draft, action);
          draft = getAsync.reduxChange(draft, action);
          draft = queryAsync.reduxChange(draft, action);
          draft = deleteAsync.reduxChange(draft, action);
          draft = normalizationReducer(draft, action);
          for (const additionalAction of additionalActions.createOrUpdateAsync) {
            draft = additionalAction.epicReducer.reduxChange(draft, action);
          }
          for (const additionalAction of additionalActions.getAsync) {
            draft = additionalAction.epicReducer.reduxChange(draft, action);
          }
          for (const additionalAction of additionalActions.miscellaneousAsync) {
            draft = additionalAction.epicReducer.reduxChange(draft, action);
          }
          return draft;
        },
        actions: {
          createOrUpdateAsync: createOrUpdateAsync.actionCreators.load,
          resetCreateOrUpdateAsync: createOrUpdateAsync.actionCreators.reset,
          getAsync: getAsync.actionCreators.load,
          resetGetAsync: getAsync.actionCreators.reset,
          queryAsync: queryAsync.actionCreators.load,
          resetQueryAsync: queryAsync.actionCreators.reset,
          deleteAsync: deleteAsync.actionCreators.load,
          resetDeleteAsync: deleteAsync.actionCreators.reset
        },
        matchers: {
          isGetAction,
          isCreateUpdateAction,
          isDeleteAction,
          isQueryAction
        },
        selectors: {
          selectById: (state, id) => {
            var _a;
            return (_a = tryGetSlice(state)) == null ? void 0 : _a.entityMap[id];
          },
          selectAll: (state) => selectAll(state),
          selectGetAsyncRequest: (state, id) => {
            var _a;
            return ((_a = tryGetSlice(state)) == null ? void 0 : _a.getAsync[id]) || getDefaultAsyncWrapperObj();
          },
          selectCreateOrUpdateAsyncRequest: (state, id) => {
            var _a;
            return ((_a = tryGetSlice(state)) == null ? void 0 : _a.createOrUpdateAsync[id]) || getDefaultAsyncWrapperObj();
          },
          selectDeleteAsyncRequest: (state, id) => {
            var _a;
            return ((_a = tryGetSlice(state)) == null ? void 0 : _a.deleteAsync[id]) || getDefaultAsyncWrapperObj();
          },
          selectQueryAsyncRequest: (state, query) => {
            var _a;
            return ((_a = tryGetSlice(state)) == null ? void 0 : _a.queryAsync[buildOdataQuery(query)]) || getDefaultAsyncWrapperObj();
          }
        }
      };
    }
  };
};
export {
  createUnifiedRestApi,
  getLoadedActionPrefix,
  updateStateArray
};
//# sourceMappingURL=utils.js.map
